import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowDown} = FiIcons;

function Hero() {
  return (
    <section className="hero" id="start">
      <img
        className="hero-waves"
        src="https://media-manager-c.questera.ai/greta-media/6a1fd9ec77a1b7736550a1122c15f1f27b12ad7af51d85a796d67feb48a26b8cef5743aa9bc766e63e43fa75e33ff1be/images/aW1hZ2UvanBlZw==/1f4f1e6582970695ba7b561104f1e3d0.jpg"
        alt="Herzschlag Hamburg auf einem bunten psychedelischen Wellenmuster"
      />
      <motion.div
        className="hero-copy"
        initial={{opacity: 0, y: 18}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.7, delay: 0.25}}
      >
        <span className="hero-kicker" style={{color: '#FFFFFF'}}>Brand Strategy · 2027</span>
        <h1>Ein Festival mit <em style={{color: '#FFFFFF'}}>Herz</em>.</h1>
        <p>Brand Strategy &amp; Styleguide – Das moderne Boutique-Schlagerfestival.</p>
        <a href="#identitaet" className="hero-link">
          Die Marke entdecken <SafeIcon icon={FiArrowDown} />
        </a>
      </motion.div>
      <span className="hero-side-label">HAMBURG · 2027</span>
    </section>
  );
}

export default Hero;